import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { CMS_BASE_URL } from "../../../axios";
import { notify } from "../../../util/helpers";

const initialState = {
  pinnedContentLoading: false,
  patientPinnedContent: [],
  pinnedContentClassifications: [],
  pinnedContentMedia: {
    audios: [],
    posts: [],
    paths: [],
    tiktoks: [],
    "view-medicas": [],
  },
};

export const fetchPatientPCLogic = createAsyncThunk(
  "patient/pin-content/single",
  (patientID) => {
    return axiosInstance.get("/api/post/", {
      headers: { Authorization: `JWT ${localStorage.access}` },
      params: { patient: patientID },
    });
  }
);

export const pinContentForPatientLogic = (payload) => {
  /*
    payload = {
      "type": "Article",
      "identifier": 109,
      "patient": "1900"
    }
    
  */
  return axiosInstance
    .request({
      url: "/api/post/",
      method: "post",
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(payload),
    })
    .then()
    .catch();
};

export const deletePinnedContentForPatientLogic = createAsyncThunk(
  "patient/pin-content/unpin",
  (pinned_content_id) => {
    return axiosInstance.delete(`/api/post/${pinned_content_id}/`, {
      headers: { Authorization: `JWT ${localStorage.access}` },
    });
  }
);

const DEFAULT_CLASSIFICATION_PARAMS = { isPinable: "true" };

export const fetchPCClassificationsLogic = createAsyncThunk(
  "patient/pin-content/classifications",
  (params = DEFAULT_CLASSIFICATION_PARAMS) => {
    return axiosInstance.get(`${CMS_BASE_URL}/classifications/`, { params });
  }
);

export const fetchPCMediaLogic = createAsyncThunk(
  "patient/pin-content/media",
  (type = "view-medicas") => {
    return axiosInstance.request({
      url: `${CMS_BASE_URL}/content-type/${type}/`,
      method: "get",
    });
  }
);

const pinnedContentAPICalls = {
  //* GET PINNED CONTENT FOR SINLGE PATIENT PROMISES
  [fetchPatientPCLogic.pending]: (state) => {
    state.pinnedContentLoading = true;
    state.patientPinnedContent = [];
  },
  [fetchPatientPCLogic.fulfilled]: (state, { payload }) => {
    state.pinnedContentLoading = false;
    state.patientPinnedContent = [];
    state.patientPinnedContent = payload.data;
  },
  [fetchPatientPCLogic.rejected]: (state, action) => {
    state.pinnedContentLoading = false;
    state.patientPinnedContent = [];
  },

  //* GET PINNED CONTENT CLASSIFICATIONS PROMISES
  [fetchPCClassificationsLogic.pending]: (state) => {
    state.pinnedContentLoading = true;
  },
  [fetchPCClassificationsLogic.fulfilled]: (state, { payload }) => {
    state.pinnedContentClassifications = payload.data;
    state.pinnedContentLoading = false;
  },
  [fetchPCClassificationsLogic.rejected]: (state, action) => {
    state.pinnedContentLoading = false;
  },

  //* GET PINNED CONTENT MEDIA PROMISES
  [fetchPCMediaLogic.pending]: (state) => {
    state.pinnedContentLoading = true;
  },
  [fetchPCMediaLogic.fulfilled]: (state, { payload }) => {
    state.pinnedContentLoading = false;
    let url = payload.config.url;
    let mediaType = url.includes("/content-type/")
      ? url.split("/content-type/")[1]?.replaceAll("/", "")
      : url.split(CMS_BASE_URL + "/")[1]?.replaceAll("/", "");
    state.pinnedContentMedia[mediaType] = payload.data;
  },
  [fetchPCMediaLogic.rejected]: (state, action) => {
    state.pinnedContentLoading = false;
  },

  //* PIN CONTENT FOR PATIENT PROMISES
  // [pinContentForPatientLogic.pending]: (state) => {},
  // [pinContentForPatientLogic.fulfilled]: (state, { payload }) => {
  //   /*
  //     response = {
  //       "id": 1783,
  //       "created": "2023-05-08T13:03:13.949656Z",
  //       "modified": "2023-05-08T13:03:13.949689Z",
  //       "type": "Article",
  //       "identifier": 109,
  //       "patient": 1900
  //     }
  //   */
  //   state.patientPinnedContent.push(payload.data);
  // },
  // [pinContentForPatientLogic.rejected]: (state, action) => {},

  //* UNPIN CONTENT FOR PATIENT PROMISES
  [deletePinnedContentForPatientLogic.pending]: (state) => {},
  [deletePinnedContentForPatientLogic.fulfilled]: (state, action) => {
    try {
      const itemId = action?.payload?.config?.url
        .split("/api/post/")[1]
        ?.replaceAll("/", "");
      /*
      response = {
        "id": 1783,
        "created": "2023-05-08T13:03:13.949656Z",
        "modified": "2023-05-08T13:03:13.949689Z",
        "type": "Article",
        "identifier": 109,
        "patient": 1900
      }
      */
      let temp = [...state.patientPinnedContent];
      temp = state.patientPinnedContent.filter(
        (e) => e.id !== parseInt(itemId)
      );
      state.patientPinnedContent = temp;

      notify("Content unpinned!");
    } catch (e) {
      console.log("Error unpinning data", e);
      notify("Something went wrong!", "error");
    }
  },
  [deletePinnedContentForPatientLogic.rejected]: (state, action) => {
    notify("Something went wrong!", "error");
  },
};

const pinnedContentSlice = createSlice({
  name: "pinned-content",
  initialState,
  extraReducers: (builder) => {
    Object.entries(pinnedContentAPICalls).forEach(([actionType, reducer]) => {
      builder.addCase(actionType, reducer);
    });
  },
  reducers: {
    pinned_for_patient: fetchPatientPCLogic,
    classifications: fetchPCClassificationsLogic,
    pinned_media: fetchPCMediaLogic,
    clearPinnedContent: (state) => {
      //state.patientPinnedContent = [];
      state.patientPinnedContent.length = 0;
    },
  },
});

export const { pinned_for_patient, classifications, pinned_media, clearPinnedContent  } =
  pinnedContentSlice.actions;
export default pinnedContentSlice.reducer;
